<template>
  <v-textarea
      ref="textarea"
      v-model="textValue"
      :label="labelText"
      :outlined="outlined"
      :solo="solo"
      :filled="filled"
      :placeholder="placeholder"
      :rules="textFieldRules"
      :counter="showCounter"
      :hide-details="simple"
      :rows="rows"
      :auto-grow="autoGrow"
      :hint="hint"
      :persistent-hint="Boolean(hint)"
      :disabled="disabled"
      :readonly="readonly"
      @keydown="onSubmit"
  />
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "TextArea",
    props: {
      "value": String,
      name: String,
      "placeholder": String,
      "required": Boolean,
      "min": Number,
      "max": Number,
      "rules": Array,
      "simple": Boolean,
      "submit": Function,
      "rows": Number,
      "hint": String,
      "disabled": Boolean,
      "autoGrow": {
        type: Boolean,
        default: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      outlined: {
        type: Boolean,
        default: true,
      },
      solo: {
        type: Boolean,
        default: false,
      },
      filled: {
        type: Boolean,
        default: false,
      },
      withLimit: {
        type: Boolean,
        default: false
      },
      noLabel: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      textValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("input", value === "" ? null : value)
        }
      },
      textFieldRules () {
        return [
          value => {
            if (this.required) {
              return !!value || this.error("required", [this.name]);
            }
            return true;
          },
          value => {
            if (value && this.min) {
              return (value.length >= this.min) || this.error("min", [this.min]);
            }
            return true;
          },
          value => {
            if (value && this.max) {
              return (value.length <= this.max) || this.error("max", [this.max]);
            }
            return true;
          }
        ].concat(this.rules || [])
      },
      labelText () {
        if (this.noLabel) return undefined
        if (!this.min && !this.max) {
          return this.name
        }
        if (this.min && this.max) {
          return this.label("nameWithMinAndMax", [this.name, this.min, this.max])
        }
        if (this.min) {
          return this.label("nameWithMin", [this.name, this.min])
        }
        return this.label("nameWithMax", [this.name, this.max])
      },
      showCounter () {
        if (this.withLimit) return this.min || this.max // 数字を返す
        return this.min != null || this.max != null
      }
    },
    methods: {
      onSubmit (e) {
        if (e.keyCode === 13 && e.metaKey) {
          this.$emit("submit");
        }
      },
      insertText(text) {
        const textarea = this.$refs.textarea.$refs.input
        const sentence = textarea.value
        const len = sentence.length
        let pos = textarea.selectionStart
        if (pos === undefined) {
          pos = 0
        }

        const before = sentence.substr(0, pos)
        const after = sentence.substr(pos, len)

        this.textValue = before + text + after
      }
    }
  }
</script>

<style>
div.v-textarea div.v-input__control div.v-input__slot div.v-text-field__slot textarea {
  margin-bottom: 4px;
}
</style>
